export default "__VITE_ASSET__CIiduxVw__"